import { useState, useEffect, useCallback } from "react";
import { getAllRides, updateRide } from "../services/rides/ride.api";
import { RideForm } from "../shared/forms/rideForm";
import { toast } from "../components/Toast/Toast";
import DataTable from "../components/Table/DataTable";
import { rideColumns } from "../types/rideTypes";
import { TextField } from "@mui/material";

export default function Rides() {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRide, setSelectedRide] = useState(null);

  const fetchRides = useCallback(async () => {
    setLoading(true);
    await getAllRides({
      page: page + 1,
      limit: rowsPerPage,
      ...(searchText ? { search: searchText } : {}),
    })
      .then((response) => {
        setRides(response.data);
        setTotalPage(response.totalResults);
      })
      .catch((err) => {
        toast.error(err.response?.data?.error || "Failed to fetch rides");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, rowsPerPage, searchText]);

  useEffect(() => {
    let delay = searchText ? 500 : 0;

    const debounceTimer = setTimeout(() => {
      fetchRides();
    }, delay);
    return () => clearTimeout(debounceTimer);
  }, [fetchRides, rowsPerPage, searchText]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (ride) => {
    setSelectedRide(ride);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRide(null);
  };

  const handleUpdate = async (values) => {
    try {
      await updateRide(selectedRide._id, values);
      toast.success("Ride updated successfully");
      handleClose();
      fetchRides();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update ride");
    }
  };

  return (
    <div>
      <div className="flex justify-start items-center mb-2">
        <TextField
          variant="outlined"
          size="small"
          placeholder="search by first name"
          onChange={handleSearchChange}
        />
      </div>
      <DataTable
        columns={rideColumns}
        rows={rides}
        loading={loading}
        totalCount={totalPage}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onEdit={handleEdit}
      />
      <RideForm
        open={open}
        onClose={handleClose}
        handleUpdate={handleUpdate}
        ride={selectedRide}
      />
    </div>
  );
}
